<mat-dialog-content style="text-align: center;">
	<!-- <img src="/assets/img/right-success.gif" style="width:100%;" /> -->
	<div style="    position: relative;" [innerHTML]="data.content"></div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button style="margin: 0px auto;" [mat-dialog-close]="true">Close</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <!-- <button mat-raised-button  [mat-dialog-close]="true">Yes</button> -->
</mat-dialog-actions>
